import type {ErrorMessage} from 'angular-error-repository';

export const EmailError: ErrorMessage = () => {
    return 'Error.Please enter a valid email address';
};
